import React from 'react';
import type { GridApi } from 'ag-grid-community';

import useIsDataTable from 'components/DataTable/useIsDataTable';

import useSingleMetricDateMatrixContent from './useSingleMetricDateMatrixContent';
import SingleMetricDateMatrixDataTableView from './SingleMetricDateMatrixDataTableView';
import SingleMetricDateMatrixView from './SingleMetricDateMatrixView';

const SingleMetricDateMatrixContentContainer = ({
  gadget,
  gridApi,
  setGridApi,
  setExportHandle,
}: {
  gadget: VisualisationDefinitions.SingleMetricDateMatrix;
  gridApi?: GridApi;
  setGridApi: React.Dispatch<React.SetStateAction<GridApi | undefined>>;
  // What export menus use in place of the gridApi when DataTable draws it
  setExportHandle?: (handle: DataTable.ExportHandle | undefined) => void;
}) => {
  const isDataTable = useIsDataTable('singleMetricDateMatrix');
  const props = useSingleMetricDateMatrixContent({
    gadget,
    gridApi,
    setGridApi,
  });
  return isDataTable ? (
    <SingleMetricDateMatrixDataTableView
      {...props}
      gadget={gadget}
      setExportHandle={setExportHandle}
    />
  ) : (
    <SingleMetricDateMatrixView {...props} />
  );
};

export default SingleMetricDateMatrixContentContainer;
